var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('article',{staticClass:"container",attrs:{"id":"single-page"}},[_c('h1',[_vm._v(_vm._s(_vm.page.title.rendered))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.excerpt.rendered)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }